import { Platform, StyleSheet, TextInput, ViewStyle } from 'react-native'
import React from 'react'
import { BottomSheetTextInput } from '@gorhom/bottom-sheet'
import { fontFamily } from '../../../../../../theme'
import { palette } from '../../../../../../theme/palette'

type ChatTextInputProps = React.ComponentProps<typeof BottomSheetTextInput> & {
  style?: ViewStyle
}

const ChatTextInput = (props: ChatTextInputProps) => {
  // if (Platform.OS === 'android') {
  //   return <TextInput {...props} style={[styles.input, props.style]} />
  // }
  return <BottomSheetTextInput {...props} style={[styles.input, props.style]} />
}

export default ChatTextInput

export const INPUT_HEIGHT = 48

const styles = StyleSheet.create({
  input: {
    flex: 1,
    alignSelf: 'center',

    paddingLeft: 16,
    paddingRight: 48,

    height: INPUT_HEIGHT,
    borderRadius: INPUT_HEIGHT,
    borderWidth: 2,
    borderColor: palette.black,

    backgroundColor: '#F6F2E9',
    color: palette.black,

    fontSize: 16,
    fontFamily: fontFamily.GTAmericaStandardRegular
  }
})
